module.exports = __webpack_public_path__ + "static/media/boat-img-45.aea8abe2.jpg";